import { useAcademySalesOfferRetrieve } from "./generated/academy/academy";

/** The agency's name as set in its settings (Academy offer). The apps never write a tenant's
 * name: the platform hosts several agencies. Empty while loading or when unavailable. */
export function useAcademyAgencyName(): string {
  const offer = useAcademySalesOfferRetrieve(undefined, { query: { retry: false, staleTime: 3_600_000 } });
  return offer.data?.status === 200 ? offer.data.data.agency : "";
}
